module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7kseD"))).then(() => parcelRequire('2pCXW'));